/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-06 17:46:52
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper2.tsx
 */
/**
 *  Page contains Header.
 *  Author: Luke
 *  CreatedAt: 2021-03-05
 */

import React from 'react';
import { headerHeight } from 'src/layout/Components/config';
import css from './css.less';

import Warning from '@/src/components/Antd/Modal/WarningModal';
import {
  HomeLayout,
  SalesChannelHeader,
} from '@/src/layout/SalesChannelEditorLayout/HomeLayout';
import { SalesChannelStatus } from '@/src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

//import { instanceType, AllTypes } from 'src/tools/helper';
interface IHeaderConfig {
  hasModified?: boolean;
  submit?: () => {
    submitFunction: () => void;
    isDataValid: boolean;
  };
  topTitle: string;
  description: string;
  status?: SalesChannelStatus;
  onDiscard?: () => void;
  onGoBack: () => void;
  visible?: boolean | undefined;
  onChangeVisibility?: (visible: boolean) => void;
  onDelete?: () => void;
}
interface IProps {
  leftChild?: JSX.Element;
  rightChild?: JSX.Element;
  headerProps?: Record<string, unknown>;
  headerConfig: IHeaderConfig;
  avoidSubmitWhenHasError?: boolean;
  hideLeft?: boolean;
}

const PageWrapper = (props: IProps) => {
  const {
    leftChild,
    rightChild,
    headerProps,
    headerConfig,
    avoidSubmitWhenHasError,
    hideLeft,
  } = props;

  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    visible,
    onDelete,
    onChangeVisibility,
    submit,
    status,
    topTitle,
    description,
  } = headerConfig;
  //   const showVisibility =
  //     instanceType(visible) === AllTypes.Undefined ? false : true;
  const [draftWarning, setDraftWarning] = React.useState({
    onOk: null,
    visible: false,
  });

  const [scheduledWarning, setScheduledWarning] = React.useState({
    visible: false,
  });

  const constructSubmit = () => {
    if (submit) {
      const { submitFunction, isDataValid } = submit();
      if (isDataValid) {
        submitFunction();
      } else {
        if (avoidSubmitWhenHasError && !isDataValid) {
          return;
        }
        // if (status === SalesChannelStatus.draft) {
        //   setDraftWarning({
        //     visible: true,
        //     onOk: () => {
        //       submitFunction();
        //       handleOnDraftWarningClose();
        //     },
        //   });
        // }
        if (status === SalesChannelStatus.scheduled) {
          setScheduledWarning({
            visible: true,
          });
        } else if (status === SalesChannelStatus.live) {
          setScheduledWarning({
            visible: true,
          });
        } else {
          setDraftWarning({
            visible: true,
            onOk: () => {
              submitFunction();
              handleOnDraftWarningClose();
            },
          });
        }

        return;
      }
    }
    return;
  };

  const headerData = {
    title: topTitle,
    description: description,
    status: status,
    hasModified: headerConfig.hasModified,
    submit: submit ? constructSubmit : null,
    onDiscard: headerConfig.onDiscard,
    onGoBack: headerConfig.onGoBack,
  };

  const handleOnDraftWarningClose = () => {
    setDraftWarning({
      visible: false,
      onOk: null,
    });
  };

  const handleOnScheduledWarningClose = () => {
    setScheduledWarning({
      visible: false,
    });
  };

  return (
    <div className={css.pageWrapper}>
      <Warning
        visible={draftWarning.visible}
        header={getI18n('general.warning')}
        onOk={draftWarning.onOk}
        okText={getI18n('general.save')}
        cancelText={getI18n('general.commonHeader.discard_cancel')}
        onCancel={handleOnDraftWarningClose}>
        {getI18n('general.draftVersionWarning')}
      </Warning>
      <Warning
        visible={scheduledWarning.visible}
        header='Unable to save changes'
        cancelText={getI18n('general.commonHeader.discard_cancel')}
        onCancel={handleOnScheduledWarningClose}>
        {getI18n('general.fixErrorsBeforeSave')}
      </Warning>
      <div
        className={css.header}
        // headerProps
        style={{
          top: headerHeight,
          ...(headerProps || {}),
        }}>
        <SalesChannelHeader
          onDelete={onDelete}
          onChangeVisibility={onChangeVisibility}
          visible={visible}
          //showVisibility={showVisibility}
          title={headerData.title}
          description={headerData.description}
          status={headerData.status}
          hasModified={headerData.hasModified}
          submit={headerData.submit}
          onDiscard={headerData.onDiscard}
          onGoBack={headerData.onGoBack}
        />
      </div>
      <HomeLayout
        leftChild={leftChild}
        rightChild={rightChild}
        hideRight={!rightChild}
        hideLeft={hideLeft}
      />
    </div>
  );
};
export default PageWrapper;
